module.exports = __webpack_public_path__ + "static/media/m.1780cc72.png";